// Angular
import { Component, OnInit } from '@angular/core';
import { EventsService } from 'src/app/services/events/events.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.less']
})
export class DashboardComponent implements OnInit {
  private sidebarIsToggled = false;

  constructor(private events: EventsService) { }

  ngOnInit() {
    this.listenToSidebar();
  }

  // listen to toggle sidebar triggers
  private listenToSidebar() {
    const width = window.innerWidth;

    const sidebar = document.querySelector('#sidebar') as HTMLElement;

    this.events.getSidebarToggle().subscribe(triggers => {
      this.sidebarIsToggled = !this.sidebarIsToggled;

      if (width <= 768) {
        sidebar.setAttribute('class', 'hideSidebar');

        if (this.sidebarIsToggled) {
          sidebar.setAttribute('class', 'hideSidebar');
        } else {
          sidebar.setAttribute('class', 'showSidebar');
        }

      } else {
        sidebar.setAttribute('class', 'showSidebar');

        if (!this.sidebarIsToggled) {
          sidebar.setAttribute('class', 'hideSidebar');
        } else {
          sidebar.setAttribute('class', 'showSidebar');
        }
      }
    });
  }

  // user click the sidebar and triggers it
  public toggleTheSidebar() {
    this.events.triggerSidebar();
  }

}
